<template>
  <q-page class="q-pa-md">
    <h1 class="text-h5 text-white">Healthcare Solutions</h1>
    <p>We offer AI-powered automation, patient data integration, and cloud security for healthcare providers.</p>
  </q-page>
</template>
